/* global window */
import { Router } from '../common/router';
import ReactVWO from '../lib/vwo';
import ReactGTM from '../lib/gtm';
import entryPoint from './renderEntryPoint';
import hot from './hot-loader';

const analyticsConfig = window && window.PreloadedState.analytics;

if (analyticsConfig) {
  if (analyticsConfig.gtm) {
    ReactGTM.initialize(analyticsConfig.gtm);
  }
  if (analyticsConfig.vwo) {
    ReactVWO.initialize(analyticsConfig.vwo);
  }
}

const render = () => entryPoint({
  router: hot(Router),
  initialState: window.PreloadedState,
});

render();
